/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'
import { cn, getStoreCountry } from '~/utils'
import { AmexIcon } from './AmexIcon'
import { ApplePayIcon } from './ApplePayIcon'
import type { PaymentIconProps } from './common'
import { KlarnaIcon } from './KlarnaIcon'
import { MastercardIcon } from './MastercardIcon'
import { PaypalIcon } from './PaypalIcon'
import { VippsIcon } from './VippsIcon'
import { VisaIcon } from './VisaIcon'

export interface PaymentIconsProps extends HTMLElementProps<'div'> {
	size: NonNullable<PaymentIconProps['size']>
	hide?: ['paypal' | 'vipps' | 'klarna']
}

export const PaymentIcons: React.FC<PaymentIconsProps> = ({ className, children, hide, size, ...props }) => (
	<div className={cn('list flex h-12 items-center gap-2', className)} {...props}>
		{getStoreCountry() === 'NO' && <VippsIcon size={size} />}
		{hide?.includes('klarna') || <KlarnaIcon size="small" />}
		{getStoreCountry() === 'EU' && <PaypalIcon size={size} />}
		<MastercardIcon size={size} />
		<VisaIcon size={size} />
		{getStoreCountry() === 'US' && <AmexIcon size={size} />}
		<ApplePayIcon size={size} />
		{children}
	</div>
)
